export default "__VITE_ASSET__C76uooI8__"